import request from '@/utils/request';

const path = 'api/v1';

const prodOrderPost = data => request({
  url: `${path}/products/order`,
  method: 'Post',
  data,
});

const prodOrderAddBox = data => request({
  url: `${path}/products/order/addBox`,
  method: 'Put',
  data,
});

const prodOrderdelBox = data => request({
  url: `${path}/products/order/delBox`,
  method: 'Put',
  data,
});

const prodOrderUpdate = data => request({
  url: `${path}/products/order`,
  method: 'Put',
  data,
});

const prodOrderList = data => request({
  url: `${path}/products/order`,
  method: 'Get',
  params: data,
});

const prodOrderDetailById = data => request({
  url: `${path}/products/order/detail`,
  method: 'Get',
  params: data,
});

const prodOrderDelete = data => request({
  url: `${path}/products/order`,
  method: 'Delete',
  params: data,
});

const printProductOrder = data => request({
  url: `${path}/print/products/order`,
  method: 'Put',
  data,
});

const productOrderNoSend = data => request({
  url: `${path}/send/products/order`,
  method: 'Put',
  data,
});

const productOrderNoConfirm = data => request({
  url: `${path}/confirm/products/order`,
  method: 'Put',
  data,
});

export {
  prodOrderPost,
  prodOrderAddBox,
  prodOrderdelBox,
  prodOrderUpdate,
  prodOrderList,
  prodOrderDetailById,
  prodOrderDelete,
  printProductOrder,
  productOrderNoSend,
  productOrderNoConfirm,
};
